module.exports = __webpack_public_path__ + "img/nf.f42ae4f.svg";